function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n   font-family: SharpSansSemiBold, sans-serif;\n   max-width: 300px;\n   overflow: hidden;\n   white-space: nowrap;\n   text-overflow: ellipsis;\n   color: ", ";\n\n   :after {\n      content: none;\n   }\n\n   ", " {\n      ", ", ", " {\n         display: inline;\n      }\n\n      ", " {\n         display: none;\n      }\n   }\n\n   &:hover,\n   &:focus,\n   &:active {\n      outline: none;\n      color: ", ";\n      border-bottom-color: ", ";\n   }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n   display: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   color: ", ";\n   display: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import styled from 'styled-components';
import { createBreakpoint } from '../../util/createBreakpoint';
import { TopNavMenuLink } from './TopNavMenuLink';
var WelcomeSpan = styled.span(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.brandColors.lightGray;
});
var UsernameSpan = styled.span(_templateObject2());
var IconSpan = styled.span(_templateObject3());
var NavLink = styled(TopNavMenuLink)(_templateObject4(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.brandColors.white;
}, function (_ref3) {
  var theme = _ref3.theme,
      _ref3$expandUserAt = _ref3.expandUserAt,
      expandUserAt = _ref3$expandUserAt === void 0 ? 'sm' : _ref3$expandUserAt;
  return createBreakpoint('above', expandUserAt, theme);
}, WelcomeSpan, UsernameSpan, IconSpan, function (_ref4) {
  var theme = _ref4.theme;
  return theme.semanticColors.secondary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.semanticColors.secondary;
});

var TopNavUserLink = function TopNavUserLink(_ref6) {
  var username = _ref6.username,
      props = _objectWithoutProperties(_ref6, ["username"]);

  return /*#__PURE__*/React.createElement(NavLink, props, /*#__PURE__*/React.createElement(IconSpan, null, /*#__PURE__*/React.createElement("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 16 16",
    size: "20",
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 100-6 3 3 0 000 6z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement(WelcomeSpan, null, "Welcome"), " ", /*#__PURE__*/React.createElement(UsernameSpan, null, username));
};

export { TopNavUserLink };